import React from "react";
import reportWebVitals from "../reportWebVitals";
import { Box, Container, Stack, Typography } from "@mui/material";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import { useTranslation } from "react-i18next";

function LinkExpired(props: {
  validity: string;
  validity_start: string;
  validity_end: string;
}) {
  const { t } = useTranslation();

  return (
    <Container>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="80vh"
      >
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding={3}
          spacing={3}
          sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}
        >
          <Typography variant="h3" paragraph>
            {props.validity === "past"
              ? t("This link expired!")
              : t("This link is not valid yet!")}
          </Typography>
          <TimerOffIcon color="action" sx={{ width: 150, height: 150 }} />
          <Typography sx={{ color: "text.secondary" }}>
            {props.validity === "past"
              ? t("This link is no longer valid. It expired at ") +
                new Date(props.validity_end).toLocaleString() +
                "."
              : t("This link is not valid yet. Wait until ") +
                new Date(props.validity_start).toLocaleString() +
                " to use it."}
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
}

export default LinkExpired;

reportWebVitals();
